import styles from '../assets/css/header.module.css';
import BankLogo from './bank-selection/BankLogo';
import { memo } from 'react';
import { LoadingSpinner } from './LoadingSpinner';
import HyperlinkCustomization from './customizations/HyperlinkCustomization';
import TextCustomization from './customizations/TextCustomization';
import { Box } from '@mui/material';

interface StepHeaderProps {
	title: string | JSX.Element | null | undefined;
	subtitle?: string | JSX.Element | null | undefined;
	bankName?: string;
	bankLogo?: string;
	withSpinner?: boolean;
}

const StepHeader = ({ title, subtitle, bankName, bankLogo, withSpinner = false }: StepHeaderProps) => {
	return (
		<Box>
			{bankName && (
				<div className={styles['header-logo-outer-container']}>
					<div className={styles['header-logo-container']}>
						{withSpinner ? (
							<LoadingSpinner>
								<div className={styles['header-bank-logo-container-with-spinner']}>
									<BankLogo bankName={bankName} bankLogo={bankLogo} />
								</div>
							</LoadingSpinner>
						) : (
							<div className={styles['header-bank-logo-container']}>
								<BankLogo bankName={bankName} bankLogo={bankLogo} />
							</div>
						)}
					</div>
				</div>
			)}
			<div className={styles['step-header-content']} style={{ marginTop: withSpinner ? '10px' : '0' }}>
				<div className={styles['step-header']}>
					<h2 className={styles['step-header-h1']} role="heading" aria-level={1}>
						<TextCustomization content={title} />
					</h2>
				</div>
				{subtitle && (
					<div className={styles['step-header-text-div']}>
						<span className={styles['step-header-text']}>
							<HyperlinkCustomization content={subtitle} />
						</span>
					</div>
				)}
			</div>
		</Box>
	);
};

export default memo(StepHeader);
